console.log('once loaded - utils.js');
window.Utils = window.Utils || {};

Utils.seasons = [
    {
        from : "2024-03-02",
        to : "2024-05-18",
    },
    {
        from : "2024-05-18",
        to : "2024-06-08",
    },
    {
        from : "2024-06-08",
        to : "2024-06-29",
    },
    {
        from : "2024-06-29",
        to : "2024-07-27",
    },
    {
        from : "2024-07-27",
        to : "2024-08-24",
    },
    {
        from : "2024-08-24",
        to : "2024-09-07",
    },
    {
        from : "2024-09-07",
        to : "2024-09-21",
    },
    {
        from : "2024-09-21",
        to : "2024-10-27",
    },

]


Utils = {
    rooms : [
        {
            code : 'BiloVite',
            lang : {
                it : "Bilocale Vite",
                en : "One Room Vite"
            },
            guest: 4,
            clean: 0,
            seasons : [
                {
                    from : Utils.seasons[0].from,
                    to : Utils.seasons[0].to,
                    price : 70
                },
                {
                    from : Utils.seasons[1].from,
                    to : Utils.seasons[1].to,
                    price : 80
                },
                {
                    from : Utils.seasons[2].from,
                    to : Utils.seasons[2].to,
                    price : 105
                },
                {
                    from : Utils.seasons[3].from,
                    to : Utils.seasons[3].to,
                    price : 130
                },
                {
                    from : Utils.seasons[4].from,
                    to : Utils.seasons[4].to,
                    price : 160
                },
                {
                    from : Utils.seasons[5].from,
                    to : Utils.seasons[5].to,
                    price : 130
                },
                {
                    from : Utils.seasons[6].from,
                    to : Utils.seasons[6].to,
                    price : 105
                },
                {
                    from : Utils.seasons[7].from,
                    to : Utils.seasons[7].to,
                    price : 80
                },

            ]
        },
        {
            code : 'TriloOleandro',
            lang : {
                it : "Trilocale Oleandro",
                en : "Two Rooms Oleandro"
            },
            guest: 6,
            clean: 0,
            seasons : [
                {
                    from : Utils.seasons[0].from,
                    to : Utils.seasons[0].to,
                    price : 85
                },
                {
                    from : Utils.seasons[1].from,
                    to : Utils.seasons[1].to,
                    price : 95
                },
                {
                    from : Utils.seasons[2].from,
                    to : Utils.seasons[2].to,
                    price : 120
                },
                {
                    from : Utils.seasons[3].from,
                    to : Utils.seasons[3].to,
                    price : 160
                },
                {
                    from : Utils.seasons[4].from,
                    to : Utils.seasons[4].to,
                    price : 195
                },
                {
                    from : Utils.seasons[5].from,
                    to : Utils.seasons[5].to,
                    price : 160
                },
                {
                    from : Utils.seasons[6].from,
                    to : Utils.seasons[6].to,
                    price : 120
                },
                {
                    from : Utils.seasons[7].from,
                    to : Utils.seasons[7].to,
                    price : 95
                },

            ]
        },
        {
            code : 'TriloBouganville',
            lang : {
                it : "Trilocale Bouganville",
                en : "Two Rooms Bouganville"
            },
            guest: 6,
            clean: 0,
            seasons : [
                {
                    from : Utils.seasons[0].from,
                    to : Utils.seasons[0].to,
                    price : 95
                },
                {
                    from : Utils.seasons[1].from,
                    to : Utils.seasons[1].to,
                    price : 110
                },
                {
                    from : Utils.seasons[2].from,
                    to : Utils.seasons[2].to,
                    price : 135
                },
                {
                    from : Utils.seasons[3].from,
                    to : Utils.seasons[3].to,
                    price : 180
                },
                {
                    from : Utils.seasons[4].from,
                    to : Utils.seasons[4].to,
                    price : 220
                },
                {
                    from : Utils.seasons[5].from,
                    to : Utils.seasons[5].to,
                    price : 180
                },
                {
                    from : Utils.seasons[6].from,
                    to : Utils.seasons[6].to,
                    price : 135
                },
                {
                    from : Utils.seasons[7].from,
                    to : Utils.seasons[7].to,
                    price : 110
                },

            ]
        },
        {
            code : 'VillinoOleandro',
            lang : {
                it : "Villino Oleandro",
                en : "Villa with three rooms Oleandro"
            },
            guest: 8,
            clean: 0,
            seasons : [
                {
                    from : Utils.seasons[0].from,
                    to : Utils.seasons[0].to,
                    price : 110
                },
                {
                    from : Utils.seasons[1].from,
                    to : Utils.seasons[1].to,
                    price : 125
                },
                {
                    from : Utils.seasons[2].from,
                    to : Utils.seasons[2].to,
                    price : 145
                },
                {
                    from : Utils.seasons[3].from,
                    to : Utils.seasons[3].to,
                    price : 190
                },
                {
                    from : Utils.seasons[4].from,
                    to : Utils.seasons[4].to,
                    price : 255
                },
                {
                    from : Utils.seasons[5].from,
                    to : Utils.seasons[5].to,
                    price : 190
                },
                {
                    from : Utils.seasons[6].from,
                    to : Utils.seasons[6].to,
                    price : 145
                },
                {
                    from : Utils.seasons[7].from,
                    to : Utils.seasons[7].to,
                    price : 125
                },

            ]
        },
        {
            code : 'VillinoBouganville',
            lang : {
                it : "Villino Bouganville",
                en : "Villa with three rooms Bouganville"
            },
            guest: 8,
            clean: 0,
            seasons : [
                {
                    from : Utils.seasons[0].from,
                    to : Utils.seasons[0].to,
                    price : 125
                },
                {
                    from : Utils.seasons[1].from,
                    to : Utils.seasons[1].to,
                    price : 145
                },
                {
                    from : Utils.seasons[2].from,
                    to : Utils.seasons[2].to,
                    price : 165
                },
                {
                    from : Utils.seasons[3].from,
                    to : Utils.seasons[3].to,
                    price : 210
                },
                {
                    from : Utils.seasons[4].from,
                    to : Utils.seasons[4].to,
                    price : 290
                },
                {
                    from : Utils.seasons[5].from,
                    to : Utils.seasons[5].to,
                    price : 210
                },
                {
                    from : Utils.seasons[6].from,
                    to : Utils.seasons[6].to,
                    price : 165
                },
                {
                    from : Utils.seasons[7].from,
                    to : Utils.seasons[7].to,
                    price : 145
                },

            ]
        },
        {
            code : 'VillaIrma',
            lang : {
                it : "Villa Irma",
                en : "Villa Irma with three rooms and veranda"
            },
            guest: 9,
            clean: 0,
            seasons : [
                {
                    from : Utils.seasons[0].from,
                    to : Utils.seasons[0].to,
                    price : 130
                },
                {
                    from : Utils.seasons[1].from,
                    to : Utils.seasons[1].to,
                    price : 160
                },
                {
                    from : Utils.seasons[2].from,
                    to : Utils.seasons[2].to,
                    price : 185
                },
                {
                    from : Utils.seasons[3].from,
                    to : Utils.seasons[3].to,
                    price : 240
                },
                {
                    from : Utils.seasons[4].from,
                    to : Utils.seasons[4].to,
                    price : 320
                },
                {
                    from : Utils.seasons[5].from,
                    to : Utils.seasons[5].to,
                    price : 240
                },
                {
                    from : Utils.seasons[6].from,
                    to : Utils.seasons[6].to,
                    price : 185
                },
                {
                    from : Utils.seasons[7].from,
                    to : Utils.seasons[7].to,
                    price : 160
                },

            ]
        },
    ],
    providers : {
        airbnb : {
            percent : 10,
            fee : 0,
            icon : '<span class="icon-airbnb"></span>',
        },
        booking : {
            percent : 20,
            fee: 0,
            icon : '<span class="icon-booking"><span class="path1"></span><span class="path2"></span></span>'
        }
    },

    getLanguage: () => {
        let lang = $('body').attr('data-language')
        return lang
    },

    // date format aaaa-mm-dd
    formatDate: (date) => {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();
        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;
        return [year, month, day].join('-');
    },

    // from number to currency
    formatMoney: (number, decPlaces, decSep, thouSep) => {
        decPlaces = isNaN(decPlaces = Math.abs(decPlaces)) ? 0 : decPlaces // decimal views
        decSep = typeof decSep === "undefined" ? "," : decSep
        thouSep = typeof thouSep === "undefined" ? "." : thouSep
        var currency = "€ "
        var sign = number < 0 ? "-" : ""
        var i = String(parseInt(number = Math.abs(Number(number) || 0).toFixed(decPlaces)))
        var j = (j = i.length) > 3 ? j % 3 : 0

        return currency + sign +
            (j ? i.substr(0, j) + thouSep : "") +
            i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + thouSep) +
            (decPlaces ? decSep + Math.abs(number - i).toFixed(decPlaces).slice(2) : ",00");
    },

    // calculate days from two dates
    calcDaysDifference: ($finish, $start) => {
        let diffTime = Math.abs($finish - $start);
        let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        return diffDays
    },

    // calculate price of the stay
    holidayPrice: ($object, $arrive, $departure) => {
        console.log('Arrive: '+$arrive+' --- Departure: '+$departure)
        let $price = 0
        let startDate = new Date($arrive)
        let finishDate = new Date($departure)
        let days = Utils.calcDaysDifference(finishDate, startDate)
        let results = {};
        results.period = {
            days: days,
            from: $arrive,
            to: $departure
        }

        let tempDate = new Date($arrive)
        let crossSeason = false

        $($object.seasons).each((index, el) => {
            let seasonStart = new Date(el.from)
            let seasonEnd = new Date(el.to)
            let seasonPrice = el.price

            if ((seasonStart <= tempDate) || crossSeason ){
                let days = 0
                if (finishDate <= seasonEnd){
                    days = Utils.calcDaysDifference(finishDate,tempDate)
                    $price = $price + (days * seasonPrice)
                    crossSeason = false
                    console.log($object.lang.it + ': ' + days + ' days at price ' + seasonPrice)
                }else{
                    if (seasonEnd > tempDate){
                        days = Utils.calcDaysDifference(seasonEnd,tempDate)
                        $price = $price + (days * seasonPrice)
                        tempDate = new Date(seasonEnd)
                        crossSeason = true
                        console.log($object.lang.it + ': ' + days + ' days at price ' + seasonPrice)
                    }
                }
            }

        })

        let percentDiscount = 0
        let percentDiscountDay = 0

        if (days >= 21){
            percentDiscount = 10
            percentDiscountDay = 21
        }else if (days >= 10){
            percentDiscount = 5
            percentDiscountDay = 10
        }
        let amountDiscount = $price * percentDiscount / 100

        results.price = {
            regular: $price,
            clean : $object.clean,
            grandTotalRegular : Utils.formatMoney($price + $object.clean),
            discount : {
                flag : days >= 10 ? true : false,
                percent : percentDiscount + '%',
                amount : '- ' + Utils.formatMoney(amountDiscount),
                day : percentDiscountDay,
            },
            grandTotalPrice :  Utils.formatMoney($price + $object.clean - amountDiscount)
        }

        let differencePriceAirbnb = ($price * Utils.providers.airbnb.percent / 100) + ($price * Utils.providers.airbnb.fee / 100)
        let differencePriceBooking = $price * Utils.providers.booking.percent / 100
        results.provider = {
            airbnb : {
                price: Utils.formatMoney($price + differencePriceAirbnb + Utils.providers.airbnb.clean),
                difference : '- ' + Utils.formatMoney(differencePriceAirbnb),
            },
            booking : {
                price: Utils.formatMoney($price + differencePriceBooking + Utils.providers.booking.clean),
                difference : '- ' + Utils.formatMoney(differencePriceBooking),
            }
        }

        console.log(results)
        return results
    },

    // populate price
    populatePrice :($div, $results) => {
        $div.find('.price-from').hide()
        $div.find('.js-clean').html($results.price.clean)
        let price = $div.find('.price-amount .price')
        let fullPrice = $div.find('.price-amount .full-price')
        let discountDesc = $div.find('.discount-desc')
        let providers = $div.find('.providers')
        //let discountAmount = discountDesc.find('.discount-amount')
        let discountPercent = discountDesc.find('.discount-percent')
        let discountDays = discountDesc.find('.discount-days')

        price.html($results.price.grandTotalPrice)
        fullPrice.html($results.price.grandTotalRegular)
        $div.find('.hidden-price-discounted').val($results.price.grandTotalPrice)
        $div.find('.hidden-price-original').val($results.price.grandTotalRegular)

        //discountAmount.html($results.price.discount.amount)
        //discountPercent.html($results.price.discount.percent)
        discountDays.html($results.price.discount.day)
        if ($results.price.discount.flag){
            discountDesc.show()
            fullPrice.show()
        }else{
            discountDesc.hide()
            fullPrice.hide()
        }

        providers.html('')
        providers.append('<div>'+ Utils.providers.airbnb.icon + $results.provider.airbnb.difference + '</div>')
        providers.append('<div>'+ Utils.providers.booking.icon + $results.provider.booking.difference + '</div>')

        $div.find('.price-content').show()
    },

    buildObjectRoom : ($bookingWidget, $code) => {
        var apartmentObjectTemp = Utils.getRoomByCode($code)
        var apartmentName = apartmentObjectTemp.lang[Utils.getLanguage()]
        $bookingWidget.find('.hidden-room').val(apartmentName)
        $bookingWidget.find('.js-price-from').html(Utils.formatMoney(apartmentObjectTemp.seasons[0].price))
        return apartmentObjectTemp

    },

    // get apartment object from code
    getRoomByCode : ($code) => {
        let apartment
        $(Utils.rooms).each(function(index, item) {
            if (item.code === $code){
                apartment = Utils.rooms[index]
            }
        })
        return apartment
    },

    stringToBoolean(string) {
        if (string === 'true'){
            return true
        } else if (string === 'false' || string === undefined){
            return false
        }
    }

}